import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, queryClient } from '@/api/common';
import type { Admin } from '@/api/partners/admins/types';
import { useAdmin } from '@/api/partners/admins/use-admin';

type Response = {
  data: {
    ownerOnboardingCompleted: boolean;
  };
};

export const useCompleteOwnerOnboarding = createMutation<
  Response,
  void,
  AxiosError
>({
  mutationFn: async () =>
    client
      .post('v2/internal/partners/admins/owner_onboarding')
      .then((response) => response.data),
  onSuccess: (result) => {
    queryClient.setQueryData(
      useAdmin.getKey(),
      (current: Admin | undefined) => {
        if (!current) {
          return current;
        }

        return {
          ...current,
          ownerOnboardingCompleted: result.data.ownerOnboardingCompleted,
        };
      }
    );
  },
});
